var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "p",
    { staticClass: "subtitle" },
    _vm._l(_vm.totals, function (value, index) {
      return _c("span", { key: index }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shows[index],
                expression: "shows[index]",
              },
            ],
          },
          [
            _vm._v(" " + _vm._s(_vm.labels[index]) + ": "),
            _c(
              "span",
              { class: [value >= 0 ? "has-text-success" : "has-text-danger"] },
              [
                _vm._v(
                  _vm._s(
                    _vm.$filters.formatCurrency(value, _vm.$userInfo.locale)
                  )
                ),
              ]
            ),
          ]
        ),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: index < _vm.totals.length - 1 && _vm.shows[index + 1],
                expression: "index < totals.length - 1 && shows[index + 1]",
              },
            ],
          },
          [_vm._v(",")]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }